import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, errMsg } from '../api';
import { inputCls, goldBtn } from '../ui';

const FIELDS = [['address', 'Sede legale (indirizzo completo)'], ['contact', 'Email per la privacy (es. privacy@azienda.it)'],
  ['dpo', 'DPO: nome e contatto (vuoto se non nominato)'], ['retention', 'Conservazione CV non assunti (es. 12 mesi)']];

export default function PrivacyInfoForm({ onSaved }) {
  const [f, setF] = useState({ address: '', contact: '', dpo: '', retention: '' });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get('/requests/privacy-info').then((r) => setF((p) => ({ ...p, ...r.data }))).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { await api.put('/requests/privacy-info', f); toast.success("Dati dell'informativa salvati"); onSaved(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="border border-[#1F242C] rounded-sm p-3 space-y-2" data-testid="privacy-info-form">
      <p className="text-xs text-[#A3A3A3]">Completa una volta i dati dell'informativa: verranno usati nel PDF e nella pagina di firma online.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {FIELDS.map(([k, l]) => <input key={k} value={f[k] || ''} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder={l} className={`${inputCls} h-10 px-3`} data-testid={`privacy-info-${k}`} />)}
      </div>
      <button type="button" onClick={save} disabled={busy || !f.address.trim() || !f.contact.trim() || !f.retention.trim()} className={`${goldBtn} h-9 px-4 text-sm inline-flex items-center gap-2 disabled:opacity-40`} data-testid="privacy-info-save">{busy && <Loader2 size={14} className="animate-spin" />}Salva e scarica</button>
    </div>
  );
}
